import { createOpenAPIClient } from "@marcuslongmuir/openapi-typescript-helpers";
import { contentServiceSchema } from "@teamtable/api";

export class PayloadTooLargeError extends Error {
  constructor() {
    super("Request exceeds server payload limit");
  }
}

export const apiClient = createOpenAPIClient(contentServiceSchema, {
  baseUrl: window.serverConfig?.API_URL || window.location.origin,
  fetchOverride: async (request: Request) => {
    const response = await fetch(request, { credentials: "include" });
    // Body-parser and upstream proxies may return HTML; the generated client
    // would fail JSON parsing before the heartbeat could inspect the status.
    if (response.status === 413) throw new PayloadTooLargeError();
    return response;
  },
});
